module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8a56a3bbb96757eedd16ec77f7870130.png";